const reducers = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        currentUser: action.payload,
      };
    case "REMOVE_USER":
      return {
        currentUser: {},
      };
    default:
      return state;
  }
};

export default reducers;
